var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vocabulary-image-list"},_vm._l((_vm.images),function(image){return _c('span',{key:image.thumbUrl,staticClass:"image-thumb",on:{"click":function($event){return _vm.imageClickHandler(image)}}},[_c('img',{attrs:{"src":image.thumbUrl}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }